import React from 'react';

const SEMAFORO_COLORS = {
  planned:     '#CBD5E0',
  in_progress: '#4A7CFF',
  at_risk:     '#F5A623',
  done:        '#2EA084',
  blocked:     '#E85D5D',
};

const SEMAFORO_LABEL = {
  planned:     'Pianificato',
  in_progress: 'In corso',
  at_risk:     'A rischio',
  done:        'Completato',
  blocked:     'Bloccato',
};

export default function CantiereModalHeader({ data, loading, onClose, onEdit }) {
  const titolo = data?.cantiere?.titolo || 'Cantiere';
  const status = data?.cantiere?.status || '';
  const semaforo = data?.semaforo;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '16px 24px',
      borderBottom: '1px solid var(--ds-border)',
      minHeight: 60,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 20 }}>🏗️</span>
        <div>
          <h2 style={{
            fontSize: 18, fontWeight: 700, margin: 0,
            fontFamily: 'var(--font-display)', color: 'var(--ink)',
          }}>
            {loading ? 'Caricamento...' : titolo}
          </h2>
          {!loading && (
            <div style={{ display: 'flex', gap: 8, marginTop: 4, alignItems: 'center' }}>
              {status && (
                <span style={{
                  fontSize: 11, textTransform: 'uppercase',
                  padding: '2px 8px', borderRadius: 4,
                  background: 'var(--chip)',
                  color: 'var(--ds-muted)',
                }}>
                  {status}
                </span>
              )}
              {semaforo && (
                <span style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4,
                  fontSize: 11, padding: '2px 8px', borderRadius: 4,
                  background: SEMAFORO_COLORS[semaforo] + '20',
                  color: SEMAFORO_COLORS[semaforo],
                  fontWeight: 500,
                }}>
                  <span style={{
                    width: 8, height: 8, borderRadius: '50%',
                    background: SEMAFORO_COLORS[semaforo],
                  }} />
                  {SEMAFORO_LABEL[semaforo] || semaforo}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {onEdit && !loading && (
          <button
            onClick={onEdit}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '8px 16px', borderRadius: 'var(--radius-base)',
              border: '1px solid var(--ds-border)', background: 'var(--ds-bg)',
              fontSize: 12, fontWeight: 500, color: 'var(--ds-text)',
              cursor: 'pointer',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--chip)'}
            onMouseLeave={e => e.currentTarget.style.background = 'var(--ds-bg)'}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            Modifica
          </button>
        )}
        <button
          onClick={onClose}
          style={{
            width: 44, height: 44,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: 'none', background: 'none', cursor: 'pointer',
            borderRadius: 'var(--radius-base)', fontSize: 20,
            color: 'var(--ds-muted)',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--chip)'}
          onMouseLeave={e => e.currentTarget.style.background = 'none'}
        >
          ×
        </button>
      </div>
    </div>
  );
}
